import { Controller } from "stimulus";
import axios from "axios";

export default class extends Controller {
  connect() {
    this.totalPages = Number(this.element.dataset.totalPages);
    this.currentPage = Number(this.element.dataset.currentPage);
  }

  async nextPage(event) {
    event.preventDefault();
    const url = this.element.dataset.url;
    this.currentPage++;
    event.target.innerHTML = '<i class="fa fa-spinner fa-spin tw-ml-2"></i>';
    try {
      const request = await axios.get(
        url,
        {
          params: {
            page: this.currentPage
          }
        },
        {
          headers: {
            Accept: "*/*"
          }
        }
      );

      const content = document.createElement("html");
      content.innerHTML = request.data;
      this.element
        .querySelector(".show-more-pagination__append-container")
        .insertAdjacentHTML(
          "beforeend",
          content.querySelector(".show-more-pagination__append-container")
            .innerHTML
        );

      if (this.currentPage >= this.totalPages) {
        event.target.classList.add("tw-hidden");
      }

      event.target.innerHTML = "Ver mais";
    } catch (error) {
      console.error(error);
      toastr.error("Não foi possível carregar a próxima página");
    }
  }
}
